import { render, staticRenderFns } from "./fundList.vue?vue&type=template&id=15aa172c&scoped=true&"
import script from "./fundList.vue?vue&type=script&lang=js&"
export * from "./fundList.vue?vue&type=script&lang=js&"
import style0 from "./fundList.vue?vue&type=style&index=0&id=15aa172c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa172c",
  null
  
)

export default component.exports